import { Navigate, useParams } from 'react-router-dom';
import { decodeRecordId } from '../utils/recordIds';

const sameId = (record, idKey, id) => record != null && String(record[idKey]) === String(id);

/**
 * Resolves the masked `:param` to a record: loaded list first, then the session fallback
 * (archived rows are not always in the list). Renders nothing while lists load;
 * redirects to `fallbackPath` once they are loaded and the id is unknown.
 */
export default function RecordDetailRoute({ param, idKey, records, sessionRecord, fallbackPath, render }) {
  const id = decodeRecordId(useParams()[param]);
  if (id === null) return <Navigate to={fallbackPath} replace />;
  const record = (records || []).find((row) => sameId(row, idKey, id))
    || (sameId(sessionRecord, idKey, id) ? sessionRecord : null);
  if (record) return render(record);
  if ((records || []).length === 0) return null;
  return <Navigate to={fallbackPath} replace />;
}
